import * as React from 'react'
import '../style/Color.scss'

class Color extends React.Component {
  public static displayName = 'Color'

  public render() {
    return (
      <div className="color">
        <section>
          <h1>Color 色彩搭配</h1>
          <p className="text">
            推荐使用以下颜色作为设计和开发规范，以保证页面和组件之间的视觉一致。
          </p>
        </section>
        <section>
          <h2>主色</h2>
          <p className="text">Xue-react 使用友好的蓝色作为主色。</p>
          <div className="color-example">
            <div className="color-cube" style={{ backgroundColor: '#40a9ff' }}>
              <span className="title">Light</span>
              <span className="detail">#40a9ff</span>
            </div>
            <div className="color-cube" style={{ backgroundColor: '#1890ff' }}>
              <span className="title">Primary</span>
              <span className="detail">#1890ff</span>
            </div>
            <div className="color-cube" style={{ backgroundColor: '#096dd9' }}>
              <span className="title">Dark</span>
              <span className="detail">#096dd9</span>
            </div>
          </div>
        </section>
        <section>
          <h2>功能色</h2>
          <p className="text">功能色常用于信息提示，比如成功、警告和失败。</p>
          <div className="color-example">
            <div className="color-cube" style={{ backgroundColor: '#52c41a' }}>
              <span className="title">Success</span>
              <span className="detail">#52c41a</span>
            </div>
            <div className="color-cube" style={{ backgroundColor: '#faad14' }}>
              <span className="title">Warning</span>
              <span className="detail">#faad14</span>
            </div>
            <div className="color-cube" style={{ backgroundColor: '#f5222d' }}>
              <span className="title">Error</span>
              <span className="detail">#f5222d</span>
            </div>
          </div>
        </section>
        <section>
          <h2>中性色</h2>
          <p className="text">中性色常用于文本、背景、边框、阴影等。</p>
          <div className="color-example">
            <div
              className="color-cube"
              style={{ backgroundColor: 'rgba(0, 0, 0, .85)' }}
            >
              <span className="title">Title</span>
              <span className="detail">rgba(0, 0, 0, .85)</span>
            </div>
            <div
              className="color-cube"
              style={{ backgroundColor: 'rgba(0, 0, 0, .65)' }}
            >
              <span className="title">Content</span>
              <span className="detail">rgba(0, 0, 0, .65)</span>
            </div>
            <div
              className="color-cube"
              style={{ backgroundColor: 'rgba(0, 0, 0, .45)' }}
            >
              <span className="title">Sub</span>
              <span className="detail">rgba(0, 0, 0, .45)</span>
            </div>
            <div
              className="color-cube"
              style={{
                backgroundColor: 'rgba(0, 0, 0, .25)',
                marginTop: '20px',
                color: 'rgba(0,0,0,0.45)'
              }}
            >
              <span className="title">Disabled</span>
              <span className="detail">rgba(0, 0, 0, .25)</span>
            </div>
            <div
              className="color-cube"
              style={{
                backgroundColor: 'rgba(0, 0, 0, .15)',
                marginTop: '20px',
                color: 'rgba(0,0,0,0.45)'
              }}
            >
              <span className="title">Border</span>
              <span className="detail">rgba(0, 0, 0, .15)</span>
            </div>
            <div
              className="color-cube"
              style={{
                backgroundColor: 'rgba(0, 0, 0, .04)',
                marginTop: '20px',
                color: 'rgba(0,0,0,0.45)'
              }}
            >
              <span className="title">Backgroud</span>
              <span className="detail">rgba(0, 0, 0, .04)</span>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Color



// WEBPACK FOOTER //
// ./src/components/Color.tsx